var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 1,
    d: "M15.75 12.375a2.625 2.625 0 012.625-2.625H36v13.125a5.625 5.625 0 005.625 5.625H56.25v31.125a2.625 2.625 0 01-2.625 2.625H36.391a19.572 19.572 0 01-2.82 3.75h20.054A6.375 6.375 0 0060 59.625V27.621c0-.895-.356-1.753-.989-2.386L40.766 6.989A3.375 3.375 0 0038.38 6H18.375A6.375 6.375 0 0012 12.375v22.12c1.194-.499 2.45-.881 3.75-1.135V12.375zM53.223 24.75H41.625a1.875 1.875 0 01-1.875-1.875V11.277L53.223 24.75zM36 52.5C36 61.613 28.613 69 19.5 69S3 61.613 3 52.5 10.387 36 19.5 36 36 43.387 36 52.5zM21 42a1.5 1.5 0 10-3 0v9H9a1.5 1.5 0 100 3h9v9a1.5 1.5 0 003 0v-9h9a1.5 1.5 0 000-3h-9v-9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAdd);
export default __webpack_public_path__ + "static/media/document-add.9ea71730fbbec3bb142474968bcbee22.svg";
export { ForwardRef as ReactComponent };